import { TonConnectButton, useTonAddress } from '@tonconnect/ui-react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { PyramidaUiState } from '../hooks/usePyramidaState';
import { About } from './About';
import { AddToHomeScreen } from './AddToHomeScreen';
import { LegalLinks } from './LegalLinks';
import { PartnerDashboardLink } from './PartnerDashboardLink';
import { SupportLink } from './SupportLink';

interface ProfileSheetProps {
  state: PyramidaUiState;
  open: boolean;
  onClose: () => void;
}

/** Slide-over sheet holding everything that used to live on the About tab and
 *  in the header actions: language, add-to-home, project info, legal. */
export function ProfileSheet({ state, open, onClose }: ProfileSheetProps) {
  const { t } = useTranslation();
  const address = useTonAddress();
  if (!open) return null;
  return (
    <div className="psheet" role="dialog" aria-modal="true" aria-label={t('v2.profile.title')}>
      <div className="psheet__backdrop" onClick={onClose} />
      <div className="psheet__panel">
        <div className="psheet__head">
          <span className="psheet__title">{t('v2.profile.title')}</span>
          <button type="button" className="psheet__close" onClick={onClose} aria-label={t('v2.profile.close')}>
            <X size={20} aria-hidden="true" />
          </button>
        </div>
        <div className="psheet__controls">
          {address && <TonConnectButton className="ton-connect-block" />}
          <AddToHomeScreen variant="block" />
          <PartnerDashboardLink className="partner-link--quiet" />
          <SupportLink />
        </div>
        <div className="psheet__about">
          <About state={state} />
        </div>
        <LegalLinks className="legal-links--mobile" />
      </div>
    </div>
  );
}
